import React, { useState } from 'react';
import { useWebsiteLock } from '../contexts/WebsiteLockContext';
import { X, Check } from 'lucide-react';

const WebsiteLockPopup: React.FC = () => {
  const { isLocked, message, refresh } = useWebsiteLock();
  const [dismissed, setDismissed] = useState(false);
  const [loading, setLoading] = useState(false);

  if (!isLocked || dismissed) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={() => setDismissed(true)} />

      <div className="relative bg-white dark:bg-gray-800 rounded-xl shadow-xl max-w-lg w-full mx-4 p-6 z-10">
        <button
          className="absolute top-3 right-3 p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700"
          onClick={() => setDismissed(true)}
          aria-label="Close"
        >
          <X className="w-4 h-4" />
        </button>

        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 bg-primary-50 text-primary-700 rounded-full p-3">
            <Check className="w-6 h-6" />
          </div>
          <div>
            <h3 className="text-xl font-bold mb-2">Booking Temporarily Unavailable</h3>
            <p className="text-gray-600 dark:text-gray-300 mb-4">{message}</p>

            <div className="flex items-center gap-3">
              <button
                className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700"
                onClick={() => setDismissed(true)}
              >
                Continue to site
              </button>

              <button
                className="px-3 py-2 border rounded-lg text-sm"
                onClick={async () => {
                  setLoading(true);
                  await refresh();
                  setLoading(false);
                }}
              >
                {loading ? 'Refreshing...' : 'Retry' }
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebsiteLockPopup;
